var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noticeFlag),expression:"noticeFlag"}],staticClass:"head-img"},[_c('img',{attrs:{"src":require("@/assets/notice.png")}})]),_c('div',{staticClass:"announcement"},[_c('div',{staticClass:"contain"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }